"use client";
import { jsx, Fragment } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import "../../../services/content/business.lib.js";
import { usePersonalizedEntryFromAJO } from "../../../utils/AJOPersonalizationProvider/AJOPersonalizationProviderClient.js";
import { AnnouncementBannerSkeleton } from "../../Chrome/Header/AnnouncementBanner/AnnouncementBannerSkeleton.js";
import { ClientSideAnnouncementBanner } from "../../Chrome/Header/AnnouncementBanner/ClientSideAnnouncementBanner.js";
import { AdBuilderUI } from "../../Marketing/AdBuilder/AdBuilderUI/index.js";
import { AdBuilderSkeleton } from "../../Marketing/AdBuilder/AdBuilderUI/view.skeleton.js";
import { FeatureHighlightCardV2Skeleton } from "../../Marketing/FeatureHighlightCardv2/FeatureHighlightCardV2Skeleton.js";
import { FeatureHighlightCardV2UI } from "../../Marketing/FeatureHighlightCardv2/FeatureHighlightCardV2UI.js";
import { RichTextEntryClient } from "../../Media/RichTextEntry/RichTextEntryClient.js";
import { RichTextEntrySkeleton } from "../../Media/RichTextEntry/RichTextEntrySkeleton.js";
const SegmentBasedEntryAJOClient = ({
  entry,
  locale,
  linkListProps,
  adSetCostcoProps,
  adBuilderSx
}) => {
  var _a, _b, _c, _d;
  const { entryData, isLoading } = usePersonalizedEntryFromAJO({
    entry
  });
  if (!entryData || !(entryData == null ? void 0 : entryData.personalizedEntry)) {
    if (!isLoading) {
      return null;
    }
    const defaultContentType = (_b = (_a = entry.base_content_reference) == null ? void 0 : _a[0]) == null ? void 0 : _b._content_type_uid;
    switch (defaultContentType) {
      case ContentType.AdBuilder:
        return /* @__PURE__ */ jsx(AdBuilderSkeleton, { sx: adBuilderSx });
      case ContentType.AnnouncementBanner:
        return /* @__PURE__ */ jsx(AnnouncementBannerSkeleton, {});
      case ContentType.CustomRichText:
        return /* @__PURE__ */ jsx(RichTextEntrySkeleton, {});
      case ContentType.FeatureHighlightCardV2:
        return /* @__PURE__ */ jsx(FeatureHighlightCardV2Skeleton, {});
      default:
        return null;
    }
  }
  const { personalizedEntry, contentType } = entryData;
  switch (contentType) {
    case ContentType.AdBuilder: {
      const adBuilderEntry = personalizedEntry;
      return /* @__PURE__ */ jsx(
        AdBuilderUI,
        {
          disableThirdPartyTracking: (_c = adBuilderEntry.privacy_toggle) == null ? void 0 : _c.disable_third_party_tracking,
          data: adBuilderEntry,
          isLoading: false,
          locale,
          sx: adBuilderSx,
          analyticsTitlePrefix: entry.title,
          enableOnViewTracking: true
        },
        adBuilderEntry.uid
      );
    }
    case ContentType.FeatureHighlightCardV2: {
      const featureHighlightCardV2Entry = personalizedEntry;
      return /* @__PURE__ */ jsx(
        FeatureHighlightCardV2UI,
        {
          data: featureHighlightCardV2Entry,
          isLoading: false,
          analyticsTitlePrefix: entry.title,
          enableOnViewTracking: true
        }
      );
    }
    case ContentType.CustomRichText: {
      const customRichTextEntry = personalizedEntry;
      return /* @__PURE__ */ jsx(
        RichTextEntryClient,
        {
          entryId: customRichTextEntry.uid,
          rich_text_editor: customRichTextEntry.rich_text_editor,
          ad_type: (_d = customRichTextEntry.component_size) == null ? void 0 : _d.ad_type
        }
      );
    }
    case ContentType.AnnouncementBanner:
      return /* @__PURE__ */ jsx(
        ClientSideAnnouncementBanner,
        {
          entry: personalizedEntry,
          analyticsTitlePrefix: entry.title,
          enableOnViewTracking: true
        }
      );
    default:
      return /* @__PURE__ */ jsx(Fragment, {});
  }
};
export {
  SegmentBasedEntryAJOClient
};
